import React, { useEffect } from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import styles from "./Legal.module.css";

const Legal = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.pageContainer}>
      <Navbar />

      <div className={styles.contentWrapper}>
        <h1 className={styles.title}>Legal Information</h1>
        <p className={styles.lastUpdated}>Last updated: January 4, 2026</p>

        <div className={styles.section}>
          <h2>Website Disclaimer</h2>
          <p>
            The information provided by Dukamo Coffee ("we," "us," or "our") on
            this website is for general informational purposes only. All
            information on the Site is provided in good faith, however, we make
            no representation or warranty of any kind, express or implied,
            regarding the accuracy, adequacy, validity, reliability,
            availability, or completeness of any information on the Site.
          </p>
        </div>

        <div className={styles.section}>
          <h2>External Links Disclaimer</h2>
          <p>
            The Site may contain (or you may be sent through the Site) links to
            other websites or content belonging to or originating from third
            parties. Such external links are not investigated, monitored, or
            checked for accuracy, adequacy, validity, reliability, availability,
            or completeness by us. We do not warrant, endorse, guarantee, or
            assume responsibility for the accuracy or reliability of any
            information offered by third-party websites linked through the site.
          </p>
        </div>

        <div className={styles.section}>
          <h2>Trademarks</h2>
          <p>
            "Dukamo Coffee", the Dukamo Coffee logo, and all related names,
            logos, product and service names, designs, and slogans are
            trademarks of Dukamo Coffee Trading PLC or its affiliates or
            licensors. You must not use such marks without the prior written
            permission of the Company. All other names, logos, product and
            service names, designs, and slogans on this Website are the
            trademarks of their respective owners.
          </p>
        </div>

        <div className={styles.section}>
          <h2>Contact</h2>
          <p>
            For any legal inquiries regarding these terms or the website, please
            contact us at:
            <br />
            <strong>legal@dukamocoffee.com</strong>
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Legal;
